export var ComponentType;
(function (ComponentType) {
    ComponentType["form"] = "form";
    ComponentType["lottery"] = "lottery";
})(ComponentType || (ComponentType = {}));
export var autoFillTypeMap;
(function (autoFillTypeMap) {
    autoFillTypeMap[autoFillTypeMap["hisotry"] = 1] = "hisotry";
    autoFillTypeMap[autoFillTypeMap["localPhoneNo"] = 2] = "localPhoneNo";
    autoFillTypeMap[autoFillTypeMap["loginPhoneNo"] = 3] = "loginPhoneNo";
})(autoFillTypeMap || (autoFillTypeMap = {}));
export var ClueLogCompType;
(function (ClueLogCompType) {
    ClueLogCompType[ClueLogCompType["SMART_PHONE"] = 202] = "SMART_PHONE";
    ClueLogCompType[ClueLogCompType["FORM"] = 401] = "FORM";
    ClueLogCompType[ClueLogCompType["LOTTERY"] = 501] = "LOTTERY";
    ClueLogCompType[ClueLogCompType["COUPON_PACKAGE"] = 601] = "COUPON_PACKAGE";
    ClueLogCompType[ClueLogCompType["PAY"] = 701] = "PAY";
    ClueLogCompType[ClueLogCompType["WECHAT"] = 801] = "WECHAT";
    ClueLogCompType[ClueLogCompType["WECHAT_GAME"] = 802] = "WECHAT_GAME";
    ClueLogCompType[ClueLogCompType["PAY_V4"] = 901] = "PAY_V4";
    ClueLogCompType[ClueLogCompType["CONSULT"] = 2001] = "CONSULT";
})(ClueLogCompType || (ClueLogCompType = {}));
export var ClueComponentType;
(function (ClueComponentType) {
    ClueComponentType[ClueComponentType["form"] = 1] = "form";
    ClueComponentType[ClueComponentType["lottery"] = 2] = "lottery";
    ClueComponentType[ClueComponentType["phone"] = 3] = "phone";
    ClueComponentType[ClueComponentType["consult"] = 4] = "consult";
    ClueComponentType[ClueComponentType["new_lottery"] = 5] = "new_lottery";
    ClueComponentType[ClueComponentType["vote"] = 6] = "vote";
    ClueComponentType[ClueComponentType["wechat"] = 7] = "wechat";
    ClueComponentType[ClueComponentType["pay"] = 8] = "pay";
    ClueComponentType[ClueComponentType["pay_v4"] = 9] = "pay_v4";
    ClueComponentType[ClueComponentType["wechat_game"] = 10] = "wechat_game";
})(ClueComponentType || (ClueComponentType = {}));
